import React from 'react'
import { hide, show } from '@ebay/nice-modal-react'
import SwitchActionButton from '../SwitchActionButton'
import { useWallet } from '@/components/common/WalletContext'
import BitcoinConnectDialog from '@/components/common/BitcoinConnectDialog'

const GoToWithdraw = () => {
  const { setCurrentSelectedWallet } = useWallet()
  const connectBtcWallet = () => {
    show(BitcoinConnectDialog, {
      onConnect: () => {
        setCurrentSelectedWallet('Btc')
        hide(BitcoinConnectDialog)
      },
    })
  }

  return <SwitchActionButton handleSwitch={connectBtcWallet} />
}

export default GoToWithdraw
